import { IOrganisation, SecurityPolicyGetDTO } from "./index";

export interface IUser {
  contactDetails: IContactDetails[];
  address: any;
  consumingIdentifiers: any;
  createdBy: string;
  createdDate: Date;
  displayName: string;
  id: string;
  isHomeUser: boolean;
  jobTitle: string;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  organization: IOrganisation;
  person: IPerson;
  restrictedDisplayName: string;
  source: string;
  status: any;
  userType: any;
  role?: any;
  isSelected?: boolean;
}

export interface IUserForgotPassDetails {
  security: SecurityPolicyGetDTO;
  firstname: string;
  middlename: string;
  lastname: string;
  username: string;
  displayname: string;
  UserId: string;
  organisationId: string;
}

export interface ILastUserAccess {
  username: string;
  avatar: string;
}

interface IPerson {
  address: any;
  contactDetails: IContactDetails[];
  createdBy: string;
  createtDate: Date;
  displayName: string;
  dob: Date;
  firstName: string;
  gender: string;
  homeUser: any;
  id: string;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  lastPasswordResetDate: Date;
  locale: string;
  middleName: string;
  passwordExpiryDate: Date;
  preferredName: string;
  source: string;
  status: any;
  surname: string;
  type: any;
  username: string;
  version: number;
}

interface IContactDetails {
  communicationType: string[];
  defaultContact?: boolean;
  recovery?: boolean;
  type: string;
  value: string;
}

export interface IUserDetailsRecoveryToken {
  organisationId: string
  userId: string
  username: string
}
